<template>
    <div>
        <slot v-bind:show="show" v-bind:hide="hide" />

        <modal ref="popup" size="large" @hidden="resetInitialTab()">
            <template slot="modal-body">
                <touchpoint-overview
                        :brick-id="brickId"
                        :name="brickName"
                        :type="brickType"
                        :config="brickConfig"
                        :disable-statistics="brickIsNew"

                        :incoming-connections-info="IncomingConnectionsInfo"
                        :outgoing-connections-info="OutgoingConnectionsInfo"
                        :initial-tab="initialTab"
                />
            </template>

            <template slot="modal-footer">
                <div class="row justify-content-end">
                    <div class="col-auto">
                        <button class="btn btn-secondary btn-lg" @click="hide">
                            <i class="fas fa-check-circle"/>&nbsp;&nbsp;{{resource('Button_OK')}}
                        </button>
                    </div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
    import resourceMixin from "../../../../Util/Mixins/resources";

    import Modal from '../../../../Components/Util/Modal.vue'
    import {default as TouchpointOverview, defaultTab} from "./TouchpointOverview/TouchpointOverview.vue";
    
    export default {
        name: 'journey-builder-composer-touchpoint-overview',
        components: {
            Modal,
            TouchpointOverview
        },
        mixins: [resourceMixin],
        computed: {
            popup(){
                return this.$refs.popup;
            }
        },
        methods: {
            show(tab){
                if(tab){
                    this.initialTab = tab;
                }
                
                this.popup.show();
            },
            hide(){
                this.popup.hide();
            },
            resetInitialTab(){
                this.initialTab = defaultTab;
            }
        },
        props: {
            brickId: {
                type: String,
                required: true
            },
            brickName: {
                type: String,
                required: true
            },
            brickType: {
                type: Number,
                required: true
            },
            brickConfig: {
                type: Object,
                required: true
            },
            brickIsNew: {
                type: Boolean,
                required: true
            },

            IncomingConnectionsInfo: {
                type: Array,
                required: true
            },
            OutgoingConnectionsInfo: {
                type: Array,
                required: true
            }
        },
        data: () => ({
            initialTab: defaultTab
        })
    }
</script>